// Test IDs for the Ekonomika / "Horowitzova městská banka" feature (player
// investments, company detail, GM company & share administration). See
// ./index.js for the recipe to add a new feature file.

export const ACCOUNT_ECONOMY = {
  characterMoney: 'account-character-money',
};

export const INVESTMENTS = {
  page: 'economy-investments-page',
  empty: 'economy-investments-empty',
  characterSection: 'economy-investments-character-section',
  holdingCard: 'economy-investments-holding-card',
  walletChip: 'economy-investments-wallet-chip',
};

export const WALLET_TRANSFER = {
  onlineNotice: 'economy-wallet-transfer-online-notice',
  directionDeposit: 'economy-wallet-transfer-direction-deposit',
  directionWithdraw: 'economy-wallet-transfer-direction-withdraw',
  slider: 'economy-wallet-transfer-slider',
  submitButton: 'economy-wallet-transfer-submit-button',
};

export const MARKETPLACE = {
  section: 'economy-marketplace-section',
  empty: 'economy-marketplace-empty',
  companyCard: 'economy-marketplace-company-card',
  companyLink: 'economy-marketplace-company-link',
  characterSelect: 'economy-marketplace-character-select',
  sharesSlider: 'economy-marketplace-shares-slider',
  buyButton: 'economy-marketplace-buy-button',
};

export const COMPANY_DETAIL = {
  page: 'economy-company-detail-page',
  notFound: 'economy-company-detail-not-found',
  shareholderRow: 'economy-company-detail-shareholder-row',
  historyItem: 'economy-company-detail-history-item',
  payoutItem: 'economy-company-detail-payout-item',
  ownershipChart: 'economy-company-detail-ownership-chart',
  marketChart: 'economy-company-detail-market-chart',
  adjustMarketButton: 'economy-company-detail-adjust-market-button',
};

export const MARKET_ADJUST = {
  dialog: 'economy-market-adjust-dialog',
  pctInput: 'economy-market-adjust-pct-input',
  valueInput: 'economy-market-adjust-value-input',
  noteInput: 'economy-market-adjust-note-input',
  submitButton: 'economy-market-adjust-submit-button',
};

export const ECONOMY_ADMIN = {
  page: 'economy-admin-page',
  guard: 'economy-admin-guard',
  payoutStatusCard: 'economy-admin-payout-status-card',
  companyRow: 'economy-admin-company-row',
  createCompanyButton: 'economy-admin-create-company-button',
  editCompanyButton: 'economy-admin-edit-company-button',
  toggleActiveButton: 'economy-admin-toggle-active-button',
  deleteCompanyButton: 'economy-admin-delete-company-button',
  manageSharesButton: 'economy-admin-manage-shares-button',
};

export const COMPANY_FORM = {
  dialog: 'economy-company-form-dialog',
  nameInput: 'economy-company-form-name-input',
  descriptionInput: 'economy-company-form-description-input',
  imageFileInput: 'economy-company-form-image-file-input',
  imagePreview: 'economy-company-form-image-preview',
  imageRemoveButton: 'economy-company-form-image-remove-button',
  totalValueZlatkaInput: 'economy-company-form-total-value-zlatka-input',
  weeklyProfitZlatkaInput: 'economy-company-form-weekly-profit-zlatka-input',
  npcOwnerNameInput: 'economy-company-form-npc-owner-name-input',
  percentForSaleInput: 'economy-company-form-percent-for-sale-input',
  submitButton: 'economy-company-form-submit-button',
};

export const PLAYER_PANEL = {
  nav: 'account-player-panel',
  accountLink: 'account-player-panel-account-link',
  bankLink: 'account-player-panel-bank-link',
  logoutButton: 'account-player-panel-logout-button',
};

export const GM_PANEL = {
  nav: 'account-gm-panel',
  economyLink: 'account-gm-panel-economy-link',
  galleryLink: 'account-gm-panel-gallery-link',
  accountsLink: 'account-gm-panel-accounts-link',
  patchesLink: 'account-gm-panel-patches-link',
};

export const SHARE_MANAGER = {
  dialog: 'economy-share-manager-dialog',
  characterSearchInput: 'economy-share-manager-character-search-input',
  characterSearchResult: 'economy-share-manager-character-search-result',
  sharesInput: 'economy-share-manager-shares-input',
  grantButton: 'economy-share-manager-grant-button',
  revokeButton: 'economy-share-manager-revoke-button',
  transferButton: 'economy-share-manager-transfer-button',
};
